import React from 'react'
import { app } from '../../../values/ui';
import { tooltipTypes, Tooltip } from '../../../../Global/Tooltip';
import getUpdatedLabel from '../../../../../services/updateLabel';
import { useTranslation } from 'react-i18next';

export default function ProgressTableHeader(props) {
    const { scale, sorts } = props
    const {t} = useTranslation("progress_report");

    let headers = app.progressReport.headers;

    const getHeaderLabelTooltip = (label) => {
        switch (label) {
            case 'AREA':
                return (
                    <Tooltip type={tooltipTypes.area} />
                )
        }
    }

    headers[1] = {
        label: getUpdatedLabel(scale),
    };

    return (
        <thead className="tracking-table-header">
            <tr className="tracking-table-header-row">
                {headers.map((it, i) => {
                    let value = it.value;
                    let tooltip = getHeaderLabelTooltip(it.label);
                    let found = false; //
                    let iconClass = "tracking-table-header-icon";
                    let down = false;
                    if (sorts && sorts.length > 0) {
                        found = (sorts[0].type === value);
                        down = sorts[0].dir === 'asc' ? true : false;
                    }

                    // dump me for clean class naming
                    let cls = `tracking-table-header-cell ${found && 'active'}`
                    let headerClick = () => console.log("CLICKED!!!")
                    return (
                        <th key={i} onClick={headerClick} className={cls}>
                            <span className="tracking-table-header-data">
                                {t(it.label)}{tooltip}
                                {found && <Caret iconClass={iconClass} down={down} />}
                            </span>
                            {it.subText &&
                                <span className="tracking-table-header-subText">{it.subText}</span>
                            }
                        </th>
                    )
                })}
            </tr>
        </thead>
    );
}
